import React, { useState, useEffect } from "react";
import { Tree } from "antd";
import { CaretDownOutlined, CaretRightOutlined, CaretUpFilled } from "@ant-design/icons";

// Helper function to extract privilegeUniqueIds from an array of privilege objects
const getPrivilegeUniqueIds = (privileges: any[]) => {
  return privileges.map((privilege) => privilege.privilegeUniqueId);
};

const PrivilegeMapper: React.FC<{
  menuHierarchy: any[];
  preSelectedPrivileges: any[]; // Now an array of objects
  onPrivilegesChange: (checkedPrivileges: any[]) => void;
  disableMapDealerEng?: boolean; // New prop to disable MAPDEALERENGG checkbox
}> = ({
  menuHierarchy,
  preSelectedPrivileges,
  onPrivilegesChange,
  disableMapDealerEng = false,
}) => {
  const [checkedKeys, setCheckedKeys] = useState<string[]>(
    getPrivilegeUniqueIds(preSelectedPrivileges)
  );
  

  useEffect(() => {
    // If disableMapDealerEng is true, remove MAPDEALERENGG from checkedKeys
    if (disableMapDealerEng) {
      setCheckedKeys((prevKeys) =>
        prevKeys.filter((key) => key !== "MAPDEALERENGG")
      );
    }
  }, [disableMapDealerEng]);

  // Recursively transform the menuHierarchy into TreeNode structure
  const generateTreeNodes = (data: any[]) => {
    return data.map((menuItem) => {
      const { children = [], privileges = [] } = menuItem;

      // If there are privileges, generate checkboxes for them
      const privilegeNodes = privileges.map((privilege: any) => ({
        title: <>{privilege.name}</>,
        key: privilege.privilegeUniqueId,
        isLeaf: true,
        privilege, // Add the privilege object to node for easier access
        disabled:
          disableMapDealerEng &&
          privilege.privilegeUniqueId === "MAPDEALERENGG", // Disable if condition matches
      }));

      // If the item has children, generate nested nodes
      const childNodes = generateTreeNodes(children) as any;

      return {
        title: (
          <h4 style={{ fontFamily: "Montserrat-SemiBold" }}>
            {menuItem.dispName}
          </h4>
        ),
        key: menuItem.menuUniqueId,
        children: [...privilegeNodes, ...childNodes],
      };
    });
  };

  // Convert the menuHierarchy into AntD Tree nodes
  const treeData = generateTreeNodes(menuHierarchy);

  // Handle checking/unchecking of tree nodes
  const handleCheck = (checkedKeysValue: any, info: any) => {
    setCheckedKeys(checkedKeysValue);

    // Extract privileges from checked nodes
    const checkedPrivileges = info.checkedNodes
      .filter((node: any) => node.privilege) // Only include nodes with privileges
      .map((node: any) => node.privilege); // Map to privilege object

    // Send checked privileges back to the parent component
    onPrivilegesChange(checkedPrivileges);
  };

  useEffect(() => {
    // Set the initial checked keys when the component mounts
    setCheckedKeys(getPrivilegeUniqueIds(preSelectedPrivileges));
  }, [preSelectedPrivileges]);

  return (
    <div style={{ height: "55vh", overflowY: "auto" }}>
      <Tree
        checkable
        checkedKeys={checkedKeys}
        onCheck={handleCheck}
        defaultExpandAll
        switcherIcon={({ expanded }) =>
          expanded ? <CaretUpFilled /> : <CaretDownOutlined />
        }
        treeData={treeData}
      />
    </div>
  );
};

export default PrivilegeMapper;
